import type { ArrowType } from '../components/ArrowSection';
import type { TemplateMode } from '../components/BatchUpload';

export const ARROW_TYPES: ArrowType[] = ['single', 'double'];

export const TEMPLATES: { id: TemplateMode; label: string }[] = [
  { id: 'reaction', label: 'Reaction Scheme' },
  { id: 'molecule', label: 'Molecule' },
];

export const VIEWBOX_CONFIG = {
  width: 192,
  height: 144,
  reactantAlign: 'center' as const,
  productAlign: 'center' as const,
};

/**
 * Extra margin in **SVG user units** around extended molecule bounds before viewBox
 * normalization. Shared by reaction and molecule templates (preview + SVG download).
 */
export const VIEWBOX_EXTRA_USER_PADDING_UNITS = 1;

/**
 * Horizontal layout for the **molecular** export template only, when the current
 * reactant config was last created from **Build Structure** (blank sketcher → Save).
 * Not stored in exported JSON; other sources (import, edit existing, etc.) use centered layout.
 */
export const BUILD_MOLECULE_TEMPLATE_START_ALIGN = VIEWBOX_CONFIG.reactantAlign;

/**
 * Interactive molecule preview only (`InteractiveMolecule` + `useZoomPan`): zoom after the layout viewBox is fitted.
 * `1` ≈ use the full fitted viewBox; lower values zoom out (smaller structures); above `1` zooms in (larger bonds/atoms).
 * Clamped by `useZoomPan` min/max zoom (0.5–8).
 */
export const DEFAULT_INTERACTIVE_MOLECULE_INITIAL_ZOOM = 0.8;

/**
 * Molecule framing baseline: height of the synthetic viewBox window in structure coordinates.
 * Smaller ⇒ tighter window ⇒ **larger** bonds/atoms in the export slot. Larger ⇒ smaller structures.
 */
export const MOLECULE_FIXED_VIEWBOX_WORLD_HEIGHT = 28;

/** Uniform scale for the whole reaction row (reactant + arrow + product) inside the export frame. */
export const SCHEME_DISPLAY_ZOOM_MIN = 0;
/** Max 3× so font 12 @ 300% zoom reaches full scale (see `schemeZoom` percent UI max). */
export const SCHEME_DISPLAY_ZOOM_MAX = 3;
export const SCHEME_DISPLAY_ZOOM_DEFAULT = 1;
export const SCHEME_DISPLAY_ZOOM_STEP = 0.05;

/**
 * Extra zoom for the **center build preview** (sidebar “Preview”: both **Fit** and **100%**).
 * `canvasScale = (fit-or-1×) * PREVIEW_DISPLAY_SCALE * previewZoom`.
 * `1` = legacy sizing; raise (e.g. 1.25–1.5) for a larger default preview (you may need to scroll the preview pane).
 */
export const PREVIEW_DISPLAY_SCALE = 1;

export const TOAST_DURATIONS = {
  SHORT: 2000,
  DEFAULT: 3000,
} as const;

export const BLUR_DELAY_MS = 150;
